import React from 'react';

//helpers
import { getFormElementIconName } from '../../helpers/formElements';
import { IElementTypeInformation } from '../../interfaces/IFormElement';

//components
import Icon from '../../../global/icons/Icon';



const ElementTypeInformation = ({className, elementType, withBrackets}: IElementTypeInformation ) => {
    const elementTypeText : string = withBrackets ? `(${elementType})` : elementType
    return (
        <div className={`element-type-information ${className} ${elementType.replaceAll(' ', '-')}`}>
            <Icon className='element-type-icon' iconName={getFormElementIconName(elementType)} sizeInPx='12' color='var(--thriveGreyDark)'/>
            <span className='element-type-text'>{elementTypeText}</span>
        </div>
    );
};

export default ElementTypeInformation